import { Model_Workflow } from 'src/app/app.models';

export abstract class WorkflowOfflineDao {
    abstract doSyncWorkflowsAction(_workflows: Model_Workflow[]): Promise<void>;
    abstract doClearWorkflowsAction(): Promise<void>;
    abstract doGetWorkflowsAction(): Promise<Model_Workflow[]>;
    abstract doInsertWorkflowsAction(_workflows: Model_Workflow[]): Promise<void>;
    abstract doGetWorkflowAction(_numWorkflow: string): Promise<Model_Workflow>;
}